import { render } from "./Dialog.vue?vue&type=template&id=189ccc11"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=189ccc11&lang=css"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__